import { render, staticRenderFns } from "./EditProfileRoute.vue?vue&type=template&id=daf5d540&scoped=true&"
import script from "./EditProfileRoute.vue?vue&type=script&lang=js&"
export * from "./EditProfileRoute.vue?vue&type=script&lang=js&"
import style0 from "./EditProfileRoute.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EditProfileRoute.vue?vue&type=style&index=1&id=daf5d540&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf5d540",
  null
  
)

export default component.exports